import React, { Component } from "react";

export default class ButtonLoader extends Component
{

	constructor ( props )
	{
		super( props );
		this.props = props;

		this.state = {
			loading : false
		};

	}

	fetchData = async () =>
	{
		this.setState( { loading : true } );

		await this.props.handleData();
		this.setState((oldState) => ({
			...oldState,
			loading: false
		}))
	};

	render ()
	{
		const { loading } = this.state;

		return (
			<button tabIndex={this.props.tabIndex} className="submit" type="submit" onClick={this.fetchData} disabled={loading}>
				{loading && (
					<i
						className="fa fa-refresh fa-spin"
						style={{ marginLeft : "10px", marginBottom : "5px" }}
					/>
				)}
				{loading && <span>{this.props.loadingTxt}</span>}
				{ !loading && <span>{this.props.normalTxt}</span>}
			</button>
		);

	}
}
